'use strict';

const nonSpacePattern = /^(?=.*\S).+$/gi; //requires at least one non-space character. Single line
const alphanumeric = /^.*[A-Za-z0-9].*$/gi; //requires at least one alphanumeric character

module.exports = {

  /**
   * @see {@link https://github.com/Baggz/Amanda/blob/master/docs/json/objects/schema.md}
   * @see {@link http://tools.ietf.org/html/draft-zyp-json-schema-03}
   * pattern:  /^(?=.*\S).+$/gi
   */
  REQUIRED_STRING: {
    required: true,
    type: 'string',
    pattern: nonSpacePattern,
  },

  USERNAME: {
    required: true,
    minLength: 4,
    maxLength: 20,
    pattern: /^[a-z0-9_\-]+$/gi,
  },

  EMAIL: {
    format: 'email',
    required: true,
    maxLength: 100,
  },

  PASSWORD: {
    required: true,
    minLength: 6,
  },

  POST_TITLE: {
    required: true,
    minLength: 1,
    maxLength: 140,
    pattern: alphanumeric,
  },

  POST_BODY: {
    required: true,
    minLength: 1,
    pattern: /^[\s]*(?=.*\S).+/gi, //requires at least one non-space character. Allows new lines ANYWHERE
  },

  SUPPORT_BODY: {
    required: false,
    minLength: 5,
    maxLength: 200,
  },

  SUPPORT_HEADING: {
    required: false,
    minLength: 6,
    maxLength: 40,
  },

  SUPPORT_URI: {
    format: 'uri',
    required: false,
    minLength: 10,
    maxLength: 300,
  },

  BADGE_NAME: {
    required: true,
    minLength: 2,
    maxLength: 20,
    pattern: /^[a-z0-9][a-z0-9 ]*[a-z0-9]$/gi,
  },

  CATEGORY_NAME: {
    required: true,
    minLength: 2,
    maxLength: 20,
    pattern: nonSpacePattern,
  },

  CONDITION: {
    enum: ['condition', 'symptom', 'treatment'],
  },

  GROUP_DESCRIPTION: {
    required: true,
    minLength: 10,
    maxLength: 2000,
  },

  URI: {
    format: 'uri',
    required: false,
    minLength: 10,
    maxLength: 300, //as API stated https://github.com/HealthUnlocked/Aurora-API/blob/develop/docs/groups-endpoint/about-endpoint.md#edit-about-page-details
  },

  // http://code.google.com/p/libphonenumber/
  PHONE: {
    required: false,
  },

  POSTCODE: {
    maxLength: 10,
  },

  COMMUNITY_EVENT_NAME: {
    required: true,
    minLength: 1,
    maxLength: 1000,
    pattern: nonSpacePattern,
  },

  COMMUNITY_EVENT_DATE: {
    required: true,
  },

  COMMUNITY_EVENT_URI: {
    required: false,
    format: 'uri',
  },

  INSTAGRAM_PAGE_URI: {
    pattern: /^$|^(https?:\/\/)?(www\.)?instagram\.com\/([^\/]*)/,
  },

  FACEBOOK_PAGE_URI: {
    pattern: /^$|^(https?:\/\/)?(www\.)?facebook\.com\/([^\/]*)/,
  },

  TWITTER_PAGE_URI: {
    pattern: /^$|^(https?:\/\/)?(www\.)?twitter\.com\/(#!\/)?@?([^\/]*)/,
  },

  YOUTUBE_PAGE_URI: {
    pattern: /^$|^(https?:\/\/)?(www\.)?((youtube\.com)|(youtu\.be))\/([^\/]*)/,
  },

  REQUIRED_URI: {
    format: 'uri',
    required: true,
  },

  CAMPAIGN_NAME: {
    required: true,
    minLength: 5,
    maxLength: 90,
    pattern: nonSpacePattern,
  },

  CAMPAIGN_TITLE: {
    required: true,
    minLength: 10,
    maxLength: 40,
    pattern: nonSpacePattern,
  },

  CAMPAIGN_TEXT: {
    required: true,
    minLength: 20,
    maxLength: 140,
    pattern: nonSpacePattern,
  },

  CAMPAIGN_CTA: {
    required: true,
    minLength: 5,
    maxLength: 20,
    pattern: nonSpacePattern,
  },

};



// WEBPACK FOOTER //
// ./app/assets/js/commonSchema.js